import { ROVO_SEARCH_PAGE, ROVO_SEARCH_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const rovoSearchRoute: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: ROVO_SEARCH_PAGE,
	path: ROVO_SEARCH_PATH,
	layout: 'home',
	nav4Layout: 'expanded',
});
